<div class="dashboard-filter-designer">
  <header class="filter-designer-intro">
    <div>
      <span class="eyebrow">Dashboard query filters</span>
      <h3>Choose visible filters and global restrictions</h3>
      <p>Visible filters appear in the dashboard filter bar. Global filters use CAP expressions and are applied silently to every query for their data source.</p>
    </div>
    <span class="filter-count"><strong>{{ filters.length }}</strong> configured</span>
  </header>

  <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

  <p-tabView styleClass="dashboard-filter-tabs">
    <p-tabPanel header="Filters">
      <dw-metadata-config-filters #capFilterDesigner
        [configContext]="configContext"
        [filters]="filters"
        (filtersChange)="onFiltersChanged($event)"
        [initialFilterKey]="modalConfig.data?.initialFilterKey"
        [showAdditionalTab]="true"
        additionalTabHeading="Dashboard">

        <div additionalTab class="dashboard-options-tab">
      <section class="filter-bar-preview">
        <div class="section-heading">
          <div>
            <strong>Filter bar preview</strong>
            <small>Order follows the CAP filter list.</small>
          </div>
        </div>
        <div class="preview-chips" *ngIf="filters.length; else noFiltersPreview">
          <span class="preview-chip" *ngFor="let filter of filters" [class.selected]="filter === selectedFilter">
            <i [class]="filterIcon(filter)"></i>
            <span>{{ filterDisplay(filter) }}</span>
            <small>{{ presentationDisplay(filter) }}</small>
          </span>
        </div>
        <ng-template #noFiltersPreview>
          <div class="empty-preview"><i class="fa fa-filter"></i> Add a field filter from the CAP Add Items tab.</div>
        </ng-template>
      </section>

      <section class="selected-filter-options" *ngIf="selectedFilter && selectedUiConfig; else selectFilterMessage">
        <div class="section-heading">
          <div>
            <strong>{{ filterDisplay(selectedFilter) }}</strong>
            <small>{{ selectedFilter.attr || selectedFilter.componentName }}</small>
          </div>
          <span class="selected-badge">Selected filter</span>
        </div>

        <div class="dashboard-options-grid">
          <label>
            <span>Reporting presentation</span>
            <p-dropdown [options]="presentationOptions" optionLabel="label" optionValue="value"
              [filter]="true" filterBy="label" appendTo="body"
              [ngModel]="selectedUiConfig.presentationType"
              (ngModelChange)="onPresentationChanged($event)">
            </p-dropdown>
            <small>Automatic derives the control from CAP metadata and the selected comparer.</small>
          </label>

          <label>
            <span>Icon class</span>
            <div class="icon-input">
              <i [class]="selectedUiConfig.iconClass || 'fa fa-filter'"></i>
              <input class="form-control" [(ngModel)]="selectedUiConfig.iconClass" placeholder="fa fa-filter" />
            </div>
          </label>

          <label class="toggle-option">
            <span>
              <strong>Allow multiple values</strong>
              <small>Builds an IN-list filter and displays the selected values as one chip.</small>
            </span>
            <p-inputSwitch [(ngModel)]="selectedUiConfig.allowMultiple"></p-inputSwitch>
          </label>

          <label class="toggle-option">
            <span>
              <strong>Default to first lookup option</strong>
              <small>Useful for a descending Year lookup where the newest year is first.</small>
            </span>
            <p-inputSwitch [(ngModel)]="selectedUiConfig.defaultToFirstLookupOption"></p-inputSwitch>
          </label>
        </div>

        <div class="cap-settings-note">
          <i class="fa fa-info-circle"></i>
          Use CAP’s Configure tab for the caption, placeholder, comparison, lookup parameters, control override, and default value.
        </div>
      </section>

      <ng-template #selectFilterMessage>
        <div class="select-filter-message">
          <i class="fa fa-mouse-pointer"></i>
          Select a filter in the CAP list, then return to this Dashboard tab to configure its reporting presentation.
        </div>
      </ng-template>
        </div>
      </dw-metadata-config-filters>
    </p-tabPanel>

    <p-tabPanel header="Global Filter">
      <div class="global-filter-tab">
        <div class="global-filter-heading">
          <div>
            <strong>Data-source filters</strong>
            <small>These expressions are ANDed with visible dashboard filters and widget-specific filters.</small>
          </div>
          <span class="filter-count"><strong>{{ configuredGlobalFilterCount }}</strong> configured</span>
        </div>

        <div class="global-filter-list" *ngIf="globalFilters.length; else noGlobalFilterSources">
          <section class="global-filter-source" *ngFor="let globalFilter of globalFilters">
            <div class="global-filter-source-copy">
              <span class="global-filter-source-icon"><i class="fa fa-database"></i></span>
            <div>
              <strong>{{ globalFilter.dataSourceItemName }}</strong>
              <small>Applied to every summary and chart query using this data source. Put the data-source field on the left side of each comparison.</small>
            </div>
            </div>
            <dw-expression-picker-control
              [(ngModel)]="globalFilter.filterExpression"
              [contextNames]="modalConfig.data?.contextNames || []"
              [item]="globalFilter.dataSourceItemName"
              addButtonText="Add filter"
              editButtonText="Edit filter">
            </dw-expression-picker-control>
          </section>
        </div>

        <ng-template #noGlobalFilterSources>
          <div class="select-filter-message">
            <i class="fa fa-database"></i>
            Add a default data source or a chart data source before configuring global filters.
          </div>
        </ng-template>

        <div class="cap-settings-note">
          <i class="fa fa-shield-alt"></i>
          Global filters scope report results but do not replace server-side authorization.
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
